import { render, staticRenderFns } from "./ReferralGuideDetail.vue?vue&type=template&id=90a44e40&scoped=true&"
import script from "./ReferralGuideDetail.vue?vue&type=script&lang=js&"
export * from "./ReferralGuideDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReferralGuideDetail.vue?vue&type=style&index=0&id=90a44e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a44e40",
  null
  
)

export default component.exports